import { Component, inject, input } from '@angular/core';
import { DokaModalController, DokaModal, DokaButton } from '@doka/angular-core';
import { I18NextEagerPipe } from 'angular-i18next';

@Component({
  templateUrl: './delete-modal.component.html',
  imports: [DokaModal, I18NextEagerPipe, DokaButton],
})
export class DeleteModalComponent {
  private modalCtrl = inject(DokaModalController);
  public modalTitle = input.required<string>();
  public text = input.required<string>();

  protected closeModal() {
    this.modalCtrl.dismiss();
  }

  protected confirmDelete() {
    this.modalCtrl.dismiss(true, 'delete');
  }
}
